"use client";

import { useEffect, useRef } from "react";

import { Button } from "@/components/base/buttons/button";
import { capturePosthogException } from "@/lib/posthog-browser";

export default function MainError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	const hasCapturedError = useRef(false);

	useEffect(() => {
		if (hasCapturedError.current) return;
		hasCapturedError.current = true;
		void capturePosthogException(error);
		console.error("Main layout error:", error);
	}, [error]);

	return (
		<div className="flex min-h-screen flex-col">
			<main className="flex flex-1 flex-col items-center justify-center bg-secondary px-4">
				<div className="mx-auto max-w-md text-center">
					<h2 className="mb-4 text-2xl font-bold text-secondary">Something Went Wrong!</h2>
					<p className="mb-6 text-tertiary">{error.message || "An unexpected error occurred"}</p>
					<div className="flex justify-center gap-4">
						<Button color="primary" onClick={reset}>
							Try again
						</Button>
						<Button color="secondary" href="/">
							Go home
						</Button>
					</div>
				</div>
			</main>
		</div>
	);
}
